import { useEventTracking } from '@services/statsig';

import { INTAKE_ROOT_PATH } from '../routing';

import { IntakeReminderBanner } from './IntakeReminderBanner';
import { useIntakeReminder } from './useIntakeReminder';

export function IntakeReminderBannerContainer() {
  const variant = useIntakeReminder();
  const { intakeHub } = useEventTracking();
  if (!variant) return null;
  return (
    <IntakeReminderBanner
      variant={variant}
      to={INTAKE_ROOT_PATH}
      onActionClick={() => intakeHub.reminderBannerClicked({ variant })}
    />
  );
}
